import { MbUserAddressAdapter } from '../connectors'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  ADDRESS_NORMALIZER,
  ConverterService,
  InterceptorUtil,
  Occ,
  OCC_USER_ID_ANONYMOUS,
  OccEndpointsService,
  USE_CLIENT_TOKEN
} from '@spartacus/core'
import { map } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class MbOccUserAddressAdapter implements MbUserAddressAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService) {
  }

  loadAll (userId: string) {
    const url = this.occEndpoints.buildUrl('addresses', {
      urlParams: { userId },
    })
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    })
    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers)
    }
    return this.http.get<Occ.AddressList>(url, { headers }).pipe(
      map(addressList => addressList.addresses || []),
      this.converter.pipeableMany(ADDRESS_NORMALIZER)
    )
  }
}
